"use client";

import { Check, Copy, Download } from "iconoir-react";
import * as React from "react";

import { Button } from "@/components/ui/button";

interface DownloadButtonProps {
  href: string;
  label: string;
  variant?: "light" | "dark";
  className?: string;
}

export function DownloadButton({
  href,
  label,
  variant = "light",
  className,
}: DownloadButtonProps) {
  return (
    <Button
      variant={variant === "light" ? "secondary" : "secondary-overlay"}
      size="default"
      className={className}
      // Button children are merged into the render element by Base UI.
      // oxlint-disable-next-line anchor-has-content
      render={<a href={href} download />}
    >
      <Download aria-hidden />
      {label}
    </Button>
  );
}

interface CopyButtonProps {
  value: string;
  label: string;
  copiedLabel: string;
  variant?: "on-blue" | "on-dark" | "on-light";
  className?: string;
}

export function CopyButton({
  value,
  label,
  copiedLabel,
  variant = "on-blue",
  className,
}: CopyButtonProps) {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard unavailable — fail silently.
    }
  };

  const buttonVariant =
    variant === "on-light" ? "secondary" : "secondary-overlay";

  return (
    <Button
      type="button"
      variant={buttonVariant}
      size="default"
      className={className}
      onClick={handleCopy}
    >
      {copied ? <Check aria-hidden /> : <Copy aria-hidden />}
      {copied ? copiedLabel : label}
    </Button>
  );
}
